// extracted by mini-css-extract-plugin
module.exports = {"root":"Popup-module__root___1_8oj","popup":"Popup-module__popup___3gHGj"};